import RoutesChangementMotDePasse from './changement-mot-de-passe/routes';
import RoutesEcranGestion from './gestion/routes';
import RoutesModifierPersonnePhysique from './modification-personne-physique/routes';
import RoutesAdressePrincipaleAdresse from './adresse-principale/routes';
import RoutesAjoutAdresseSecondaire from './ajouter-adresse-secondaire/routes';
import RoutesModificationAdresseSecondaire from './adresse-secondaire/routes';
import RoutesModifierInformationsCompte from './modifier-informations-compte/routes';
import RoutesModifierQuestionsReponses from './modifier-questions-reponses/routes';
import RoutesAjouterPersona from './ajouter-persona/routes';
import { initSubRoutes } from '../../../utils/router';

const RoutesMonCompte = initSubRoutes({
    route: '/mon-compte',
    subroutes: {
        changementMotDePasse: RoutesChangementMotDePasse,
        ecranGestion: RoutesEcranGestion,
        modifierPersonnePhysique: RoutesModifierPersonnePhysique,
        adressePrincipale: RoutesAdressePrincipaleAdresse,
        ajouterAdresseSecondaire: RoutesAjoutAdresseSecondaire,
        modifierAdresseSecondaire: RoutesModificationAdresseSecondaire,
        modifierInformationsCompte: RoutesModifierInformationsCompte,
        modifierQuestionsReponses: RoutesModifierQuestionsReponses,
        ajouterPersona: RoutesAjouterPersona,
    },
    nom: 'Mon compte',
});

export default RoutesMonCompte;
